// useRoomCategoriesFiltering.tsx

import { useRoomCategoriesContext } from "@/contexts/RoomCategoriesContext";

export const useRoomCategoriesFiltering = (hotelId: string) => {
  const { filters, actions, computed, useRoomCategories } =
    useRoomCategoriesContext();

  const categoriesQuery = useRoomCategories(
    hotelId,
    filters.currentPage,
    computed.limit,
    computed.apiFilters
  );

  const categoriesData = categoriesQuery.data || { data: [], total: 0 };
  const categories = categoriesData.data || [];
  const totalPages = Math.ceil((categoriesData.total || 0) / computed.limit);

  return {
    categories,
    totalPages,
    isLoading: categoriesQuery.isLoading,
    error: categoriesQuery.error,

    filters,
    actions,
    computed,

    pagination: {
      currentPage: filters.currentPage,
      totalPages,
      hasNextPage: filters.currentPage < totalPages,
      hasPrevPage: filters.currentPage > 1,
      goToNextPage: () => {
        if (filters.currentPage < totalPages) {
          actions.setCurrentPage(filters.currentPage + 1);
        }
      },
      goToPrevPage: () => {
        if (filters.currentPage > 1) {
          actions.setCurrentPage(filters.currentPage - 1);
        }
      },
      goToPage: (page: number) => {
        if (page >= 1 && page <= totalPages) {
          actions.setCurrentPage(page);
        }
      },
    },

    selection: {},
  };
};
